import StarterKit from '@tiptap/starter-kit'
import Link from '@tiptap/extension-link'
import Underline from '@tiptap/extension-underline'
import Placeholder from '@tiptap/extension-placeholder'

export const createBlogExtensions = ({ placeholder = 'Почніть писати…' } = {}) => [
  StarterKit.configure({
    heading: { levels: [2, 3, 4] },
  }),
  Underline,
  Link.configure({
    openOnClick: false,
    HTMLAttributes: {
      rel: 'noopener noreferrer',
      target: '_blank',
    },
  }),
  Placeholder.configure({ placeholder }),
]
